import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ta } from '@utils/index';
import { transferPaymentColumns, transferPaymentJournalColumns } from '@utils/recordHelpers';
import FilterTableProvider from '@container/FilterTableProvider';

import ResourceTableHeaders from '@presentational/ResourceTableHeaders';
import ResourceTableBody from '@presentational/ResourceTableBody';

const propTypes = {
  records: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  
  isAdmin: PropTypes.bool,
  filterURL: PropTypes.string.isRequired,
}

const defaultProps = {
  isAdmin: false
}

const TransferPayments = (props) => {
  const columnsInfo = transferPaymentColumns(props.isAdmin);
  console.log("TransferPayments", props);

  const journalsRender = (item) => {
    if(item.brightpearl_journals){
      return(
        <div className='transfer-payment-journals mt20'>
          <ResourceTableHeaders columnsInfo={ transferPaymentJournalColumns } />
          <ResourceTableBody
            columnsInfo={ transferPaymentJournalColumns }
            items={ item.brightpearl_journals }
          />
          {/* Total display */}
          <ResourceTableBody 
            items={[{ total: item.brightpearl_journals_total_money }]} 
            columnsInfo={[
              { size: 7, header: "", accessor: "offset" },
              { size: 2, header: "", accessor: () => <strong>Total</strong> },
              { size: 3, header: "", accessor: ({ total }) => <strong>{ total }</strong> }
            ]}
          />
        </div>
      )
    }
    else{
      return(
        <div className='p10 flex justifyCenter'>
          <strong>No hay movimientos registrados</strong>
        </div>
      )
    }
  }

  return (
    <FilterTableProvider
      initialRecords={props.records}
      initialTotalPages={ props.totalPages }
      columnsInfo={ columnsInfo }
      pageProps={{ title: I18n.t("transfer_payment.other"), }}

      filterURL={props.filterURL}
      paramsName="transfer_filters"
      searchName="search_query"
      searchPlaceholder={ props.isAdmin ? I18n.t("form.placeholder.transfer_search.admin") : I18n.t("form.placeholder.transfer_search.seller") }
      users={ props.sellers }
      legacy={false}
      
      resourceTableProps={{
        renderItemExtra: journalsRender
      }}
    />
  )
};

TransferPayments.propTypes = propTypes;
TransferPayments.defaultProps = defaultProps;

export default TransferPayments;